export function getFixedDropdownPosition({
  triggerRect,
  viewportWidth,
  viewportHeight,
  preferredWidth,
  dropdownHeight,
  spacing = 8,
  margin = 8,
}) {
  const safeWidth = Math.max(margin * 2, viewportWidth - margin * 2);
  const width = Math.min(preferredWidth, safeWidth);

  const idealLeft = triggerRect.right - width;
  const maxLeft = Math.max(margin, viewportWidth - width - margin);
  const left = Math.min(Math.max(idealLeft, margin), maxLeft);

  const belowTop = triggerRect.bottom + spacing;
  const aboveTop = Math.max(margin, triggerRect.top - spacing - dropdownHeight);
  const availableBelow = Math.max(0, viewportHeight - belowTop - margin);
  const availableAbove = Math.max(0, triggerRect.top - spacing - margin);
  const shouldPlaceAbove =
    dropdownHeight > 0 &&
    availableBelow < Math.min(dropdownHeight, 160) &&
    availableAbove > availableBelow;

  return {
    left,
    top: shouldPlaceAbove ? aboveTop : belowTop,
    width,
    maxHeight: shouldPlaceAbove ? availableAbove : availableBelow,
  };
}
